var _excluded = ["color", "font", "fontSize", "selection"],
  _excluded2 = ["invalid"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isObject, mergeConfig, writeConfig } from 'vega-util';
import { AXIS_CONFIGS, isConditionalAxisValue } from './axis';
import { signalOrValueRefWithCondition, signalRefOrValue } from './compile/common';
import { getAllCompositeMarks } from './compositemark';
import { replaceExprRef } from './expr';
import { VL_ONLY_LEGEND_CONFIG } from './guide';
import { HEADER_CONFIGS } from './header';
import { defaultLegendConfig } from './legend';
import * as mark from './mark';
import { MARK_CONFIGS, PRIMITIVE_MARKS, VL_ONLY_MARK_CONFIG_PROPERTIES, VL_ONLY_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX } from './mark';
import { assembleParameterSignals } from './parameter';
import { defaultScaleConfig } from './scale';
import { defaultConfig as defaultSelectionConfig } from './selection';
import { DEFAULT_SPACING, isStep } from './spec/base';
import { extractTitleConfig } from './title';
import { duplicate, getFirstDefined, hasProperty, isEmpty, keys, omit } from './util';
export function getViewConfigContinuousSize(viewConfig, channel) {
  var _viewConfig$channel;
  return (_viewConfig$channel = viewConfig[channel]) !== null && _viewConfig$channel !== void 0 ? _viewConfig$channel : viewConfig[channel === 'width' ? 'continuousWidth' : 'continuousHeight']; // get width/height for backwards compatibility
}
export function getViewConfigDiscreteStep(viewConfig, channel) {
  var size = getViewConfigDiscreteSize(viewConfig, channel);
  return isStep(size) ? size.step : DEFAULT_STEP;
}
export function getViewConfigDiscreteSize(viewConfig, channel) {
  var _viewConfig$channel2;
  var size = (_viewConfig$channel2 = viewConfig[channel]) !== null && _viewConfig$channel2 !== void 0 ? _viewConfig$channel2 : viewConfig[channel === 'width' ? 'discreteWidth' : 'discreteHeight']; // get width/height for backwards compatibility
  return getFirstDefined(size, {
    step: viewConfig.step
  });
}
export var DEFAULT_STEP = 20;
export var defaultViewConfig = {
  continuousWidth: 200,
  continuousHeight: 200,
  step: DEFAULT_STEP
};
export function isVgScheme(rangeScheme) {
  return hasProperty(rangeScheme, 'scheme');
}
export var defaultConfig = {
  background: 'white',
  padding: 5,
  timeFormat: '%b %d, %Y',
  countTitle: 'Count of Records',
  view: defaultViewConfig,
  mark: mark.defaultMarkConfig,
  arc: {},
  area: {},
  bar: mark.defaultBarConfig,
  circle: {},
  geoshape: {},
  image: {},
  line: {},
  point: {},
  rect: mark.defaultRectConfig,
  rule: {
    color: 'black'
  },
  // Need this to override default color in mark config
  square: {},
  text: {
    color: 'black'
  },
  // Need this to override default color in mark config
  tick: mark.defaultTickConfig,
  trail: {},
  boxplot: {
    size: 14,
    extent: 1.5,
    box: {},
    median: {
      color: 'white'
    },
    outliers: {},
    rule: {},
    ticks: null
  },
  errorbar: {
    center: 'mean',
    rule: true,
    ticks: false
  },
  errorband: {
    band: {
      opacity: 0.3
    },
    borders: false
  },
  scale: defaultScaleConfig,
  projection: {},
  legend: defaultLegendConfig,
  header: {
    titlePadding: 10,
    labelPadding: 10
  },
  headerColumn: {},
  headerRow: {},
  headerFacet: {},
  selection: defaultSelectionConfig,
  style: {},
  title: {},
  facet: {
    spacing: DEFAULT_SPACING
  },
  concat: {
    spacing: DEFAULT_SPACING
  },
  normalizedNumberFormat: '.0%'
};
// Tableau10 color palette, copied from `vegaScale.scheme('tableau10')`
var tab10 = ['#4c78a8', '#f58518', '#e45756', '#72b7b2', '#54a24b', '#eeca3b', '#b279a2', '#ff9da6', '#9d755d', '#bab0ac'];
export var DEFAULT_FONT_SIZE = {
  text: 11,
  guideLabel: 10,
  guideTitle: 11,
  groupTitle: 13,
  groupSubtitle: 12
};
export var DEFAULT_COLOR = {
  blue: tab10[0],
  orange: tab10[1],
  red: tab10[2],
  teal: tab10[3],
  green: tab10[4],
  yellow: tab10[5],
  purple: tab10[6],
  pink: tab10[7],
  brown: tab10[8],
  gray0: '#000',
  gray1: '#111',
  gray2: '#222',
  gray3: '#333',
  gray4: '#444',
  gray5: '#555',
  gray6: '#666',
  gray7: '#777',
  gray8: '#888',
  gray9: '#999',
  gray10: '#aaa',
  gray11: '#bbb',
  gray12: '#ccc',
  gray13: '#ddd',
  gray14: '#eee',
  gray15: '#fff'
};
export function colorSignalConfig() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    signals: [{
      name: 'color',
      value: isObject(color) ? _objectSpread(_objectSpread({}, DEFAULT_COLOR), color) : DEFAULT_COLOR
    }],
    mark: {
      color: {
        signal: 'color.blue'
      }
    },
    rule: {
      color: {
        signal: 'color.gray0'
      }
    },
    text: {
      color: {
        signal: 'color.gray0'
      }
    },
    style: {
      'guide-label': {
        fill: {
          signal: 'color.gray0'
        }
      },
      'guide-title': {
        fill: {
          signal: 'color.gray0'
        }
      },
      'group-title': {
        fill: {
          signal: 'color.gray0'
        }
      },
      'group-subtitle': {
        fill: {
          signal: 'color.gray0'
        }
      },
      cell: {
        stroke: {
          signal: 'color.gray8'
        }
      }
    },
    axis: {
      domainColor: {
        signal: 'color.gray13'
      },
      gridColor: {
        signal: 'color.gray8'
      },
      tickColor: {
        signal: 'color.gray13'
      }
    },
    range: {
      category: [{
        signal: 'color.blue'
      }, {
        signal: 'color.orange'
      }, {
        signal: 'color.red'
      }, {
        signal: 'color.teal'
      }, {
        signal: 'color.green'
      }, {
        signal: 'color.yellow'
      }, {
        signal: 'color.purple'
      }, {
        signal: 'color.pink'
      }, {
        signal: 'color.brown'
      }, {
        signal: 'color.grey8'
      }]
    }
  };
}
export function fontSizeSignalConfig(fontSize) {
  return {
    signals: [{
      name: 'fontSize',
      value: isObject(fontSize) ? _objectSpread(_objectSpread({}, DEFAULT_FONT_SIZE), fontSize) : DEFAULT_FONT_SIZE
    }],
    text: {
      fontSize: {
        signal: 'fontSize.text'
      }
    },
    style: {
      'guide-label': {
        fontSize: {
          signal: 'fontSize.guideLabel'
        }
      },
      'guide-title': {
        fontSize: {
          signal: 'fontSize.guideTitle'
        }
      },
      'group-title': {
        fontSize: {
          signal: 'fontSize.groupTitle'
        }
      },
      'group-subtitle': {
        fontSize: {
          signal: 'fontSize.groupSubtitle'
        }
      }
    }
  };
}
export function fontConfig(font) {
  return {
    text: {
      font: font
    },
    style: {
      'guide-label': {
        font: font
      },
      'guide-title': {
        font: font
      },
      'group-title': {
        font: font
      },
      'group-subtitle': {
        font: font
      }
    }
  };
}
function getAxisConfigInternal(axisConfig) {
  var props = keys(axisConfig || {});
  var axisConfigInternal = {};
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prop = _step.value;
      var val = axisConfig[prop];
      axisConfigInternal[prop] = isConditionalAxisValue(val) ? signalOrValueRefWithCondition(val) : signalRefOrValue(val);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return axisConfigInternal;
}
function getStyleConfigInternal(styleConfig) {
  var props = keys(styleConfig);
  var styleConfigInternal = {};
  var _iterator2 = _createForOfIteratorHelper(props),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var prop = _step2.value;
      // We need to cast to cheat a bit here since styleConfig can be either mark config or axis config
      styleConfigInternal[prop] = getAxisConfigInternal(styleConfig[prop]);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return styleConfigInternal;
}
var configPropsWithExpr = [].concat(_toConsumableArray(MARK_CONFIGS), _toConsumableArray(AXIS_CONFIGS), _toConsumableArray(HEADER_CONFIGS), ['background', 'padding', 'legend', 'lineBreak', 'scale', 'style', 'title', 'view']);
/**
 * Merge specified config with default config and config for the `color` flag,
 * then replace all expressions with signals
 */
export function initConfig() {
  var specifiedConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var color = specifiedConfig.color,
    font = specifiedConfig.font,
    fontSize = specifiedConfig.fontSize,
    selection = specifiedConfig.selection,
    restConfig = _objectWithoutProperties(specifiedConfig, _excluded);
  var mergedConfig = mergeConfig({}, duplicate(defaultConfig), font ? fontConfig(font) : {}, color ? colorSignalConfig(color) : {}, fontSize ? fontSizeSignalConfig(fontSize) : {}, restConfig || {});
  // mergeConfig doesn't recurse and overrides object values.
  if (selection) {
    writeConfig(mergedConfig, 'selection', selection, true);
  }
  var outputConfig = omit(mergedConfig, configPropsWithExpr);
  for (var _i = 0, _arr = ['background', 'lineBreak', 'padding']; _i < _arr.length; _i++) {
    var prop = _arr[_i];
    if (mergedConfig[prop]) {
      outputConfig[prop] = signalRefOrValue(mergedConfig[prop]);
    }
  }
  var _iterator3 = _createForOfIteratorHelper(mark.MARK_CONFIGS),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var markConfigType = _step3.value;
      if (mergedConfig[markConfigType]) {
        // FIXME: outputConfig[markConfigType] expects that types are replaced recursively but replaceExprRef only replaces one level deep
        outputConfig[markConfigType] = replaceExprRef(mergedConfig[markConfigType]);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  var _iterator4 = _createForOfIteratorHelper(AXIS_CONFIGS),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var axisConfigType = _step4.value;
      if (mergedConfig[axisConfigType]) {
        outputConfig[axisConfigType] = getAxisConfigInternal(mergedConfig[axisConfigType]);
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  var _iterator5 = _createForOfIteratorHelper(HEADER_CONFIGS),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var headerConfigType = _step5.value;
      if (mergedConfig[headerConfigType]) {
        outputConfig[headerConfigType] = replaceExprRef(mergedConfig[headerConfigType]);
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  if (mergedConfig.legend) {
    outputConfig.legend = replaceExprRef(mergedConfig.legend);
  }
  if (mergedConfig.scale) {
    var _mergedConfig$scale = mergedConfig.scale,
      invalid = _mergedConfig$scale.invalid,
      otherScaleConfig = _objectWithoutProperties(_mergedConfig$scale, _excluded2);
    var newScaleInvalid = replaceExprRef(invalid, {
      level: 1
    });
    outputConfig.scale = _objectSpread(_objectSpread({}, replaceExprRef(otherScaleConfig)), keys(newScaleInvalid).length > 0 ? {
      invalid: newScaleInvalid
    } : {});
  }
  if (mergedConfig.style) {
    outputConfig.style = getStyleConfigInternal(mergedConfig.style);
  }
  if (mergedConfig.title) {
    outputConfig.title = replaceExprRef(mergedConfig.title);
  }
  if (mergedConfig.view) {
    outputConfig.view = replaceExprRef(mergedConfig.view);
  }
  return outputConfig;
}
var MARK_STYLES = new Set(['view'].concat(_toConsumableArray(PRIMITIVE_MARKS)));
var VL_ONLY_CONFIG_PROPERTIES = ['color', 'fontSize', 'background',
// We apply background to the spec directly.
'padding', 'facet', 'concat', 'numberFormat', 'numberFormatType', 'normalizedNumberFormat', 'normalizedNumberFormatType', 'timeFormat', 'countTitle', 'header', 'axisQuantitative', 'axisTemporal', 'axisDiscrete', 'axisPoint', 'axisXBand', 'axisXPoint', 'axisXDiscrete', 'axisXQuantitative', 'axisXTemporal', 'axisYBand', 'axisYPoint', 'axisYDiscrete', 'axisYQuantitative', 'axisYTemporal', 'scale', 'selection', 'overlay' // FIXME: Redesign and unhide this
];
var VL_ONLY_ALL_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX = _objectSpread({
  view: ['continuousWidth', 'continuousHeight', 'discreteWidth', 'discreteHeight', 'step']
}, VL_ONLY_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX);
export function stripAndRedirectConfig(config) {
  config = duplicate(config);
  var _iterator6 = _createForOfIteratorHelper(VL_ONLY_CONFIG_PROPERTIES),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _prop4 = _step6.value;
      delete config[_prop4];
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  if (config.axis) {
    // delete condition axis config
    for (var prop in config.axis) {
      if (isConditionalAxisValue(config.axis[prop])) {
        delete config.axis[prop];
      }
    }
  }
  if (config.legend) {
    var _iterator7 = _createForOfIteratorHelper(VL_ONLY_LEGEND_CONFIG),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _prop = _step7.value;
        delete config.legend[_prop];
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }
  // Remove Vega-Lite only generic mark config
  if (config.mark) {
    var _iterator8 = _createForOfIteratorHelper(VL_ONLY_MARK_CONFIG_PROPERTIES),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var _prop2 = _step8.value;
        delete config.mark[_prop2];
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
    if (config.mark.tooltip && isObject(config.mark.tooltip)) {
      delete config.mark.tooltip;
    }
  }
  if (config.params) {
    config.signals = (config.signals || []).concat(assembleParameterSignals(config.params));
    delete config.params;
  }
  var _iterator9 = _createForOfIteratorHelper(MARK_STYLES),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var markType = _step9.value;
      // Remove Vega-Lite-only mark config
      var _iterator11 = _createForOfIteratorHelper(VL_ONLY_MARK_CONFIG_PROPERTIES),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _prop6 = _step11.value;
          delete config[markType][_prop6];
        }
        // Remove Vega-Lite only mark-specific config
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      var vlOnlyMarkSpecificConfigs = VL_ONLY_ALL_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX[markType];
      if (vlOnlyMarkSpecificConfigs) {
        var _iterator12 = _createForOfIteratorHelper(vlOnlyMarkSpecificConfigs),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var _prop5 = _step12.value;
            delete config[markType][_prop5];
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }
      // Redirect mark config to config.style so that mark config only affect its own mark type
      // without affecting other marks that share the same underlying Vega marks.
      // For example, config.rect should not affect bar marks.
      redirectConfigToStyleConfig(config, markType);
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
  var _iterator10 = _createForOfIteratorHelper(getAllCompositeMarks()),
    _step10;
  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var m = _step10.value;
      // Clean up the composite mark config as we don't need them in the output specs anymore
      delete config[m];
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
  redirectTitleConfig(config);
  // Remove empty config objects.
  for (var _prop3 in config) {
    // @ts-ignore
    if (isObject(config[_prop3]) && isEmpty(config[_prop3])) {
      // @ts-ignore
      delete config[_prop3];
    }
  }
  return isEmpty(config) ? undefined : config;
}
/**
 *
 * Redirect config.title -- so that title config do not affect header labels,
 * which also uses `title` directive to implement.
 *
 * For subtitle configs in config.title, keep them in config.title as header titles never have subtitles.
 */
function redirectTitleConfig(config) {
  var _extractTitleConfig = extractTitleConfig(config.title),
    titleMarkConfig = _extractTitleConfig.titleMarkConfig,
    subtitleMarkConfig = _extractTitleConfig.subtitleMarkConfig,
    subtitle = _extractTitleConfig.subtitle;
  // set config.style if title/subtitleMarkConfig is not an empty object
  if (!isEmpty(titleMarkConfig)) {
    config.style['group-title'] = _objectSpread(_objectSpread({}, config.style['group-title']), titleMarkConfig);
  }
  if (!isEmpty(subtitleMarkConfig)) {
    config.style['group-subtitle'] = _objectSpread(_objectSpread({}, config.style['group-subtitle']), subtitleMarkConfig);
  }
  // subtitle part can stay in config.title since header titles do not use subtitle
  if (!isEmpty(subtitle)) {
    config.title = subtitle;
  } else {
    delete config.title;
  }
}
function redirectConfigToStyleConfig(config, prop,
// string = composite mark
toProp, compositeMarkPart) {
  var propConfig = compositeMarkPart ? config[prop][compositeMarkPart] : config[prop];
  if (prop === 'view') {
    toProp = 'cell'; // View's default style is "cell"
  }
  var style = _objectSpread(_objectSpread({}, propConfig), config.style[toProp !== null && toProp !== void 0 ? toProp : prop]);
  // set config.style if it is not an empty object
  if (!isEmpty(style)) {
    config.style[toProp !== null && toProp !== void 0 ? toProp : prop] = style;
  }
  if (!compositeMarkPart) {
    // For composite mark, so don't delete the whole config yet as we have to do multiple redirections.
    delete config[prop];
  }
}